import React, { useState, useEffect, Fragment, useContext } from "react";
import localization from "assets/localization/localization";
import PanelCardWithHeading from "components/tickets/panelCardWithHeading";
import Layout from "components/sales/layout/layout";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import FileUpload from "components/sales/fileUpload/fileUpload";
import CardSection from "components/sales/cardSection/cardSection";
import { Button } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import Images from "assets/images/imageData";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import ErrModalPop from "components/sales/modal/errorModal";
import DatePicker from "components/sales/datePicker/datePicker";

const CampaignCreation = ({
  addCampaignData,
  createAdsCampaign = [],
  documentUrlDataPublic,
  documentUploadUrlPublic,
  match,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isModal, setIsModal] = useState(false);
  const [formData, setFormData] = useState({
    campaign_type: "",
    campaign_subtype: "",
    user_segment: "",
    duration: "",
    est_revenue: "",
    invoice_number: "",
    attachment: "",
    poc_name: "",
    poc_mail: "",
    poc_mobile_number: "",
    pid_number: "",
    pid_name: "",
    vendor_name: "",
    carnival_date: "",
    start_date: "",
    end_date: "",
    user_remark: "",
    revenue_impression: "",
    revenue_lead_based: "",
    revenue_install: "",
    revenue_ctr: "",
    revenue_lead_conversion: "",
  });

  const [isFocus2, setIsFous2] = useState(false);
  const [minDate, setMinDate] = useState(null);
  const [errorMsg, setErrorMsg] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isErrorModal, setIsErrorModal] = useState(false);

  const setMaxToDate = (val) => {
    if (val != "Invalid date") {
      var dateParts = val.split("-");
      var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      setMinDate(dateObject);
    } else {
      setMinDate(null);
    }
  };

  useEffect(() => {
    console.log(createAdsCampaign?.status_code);
    if (
      !createAdsCampaign?.status &&
      createAdsCampaign?.status_code &&
      parseInt(createAdsCampaign?.status_code) !== 200
    ) {
      // console.log("ffffffff");
      setIsErrorModal(true);
      setErrorMsg(createAdsCampaign.message);
    } else if (
      createAdsCampaign?.status_code &&
      parseInt(createAdsCampaign?.status_code) === 200
    ) {
      setIsModal(true);
    }
  }, [createAdsCampaign]);

  const handleSubmit = async (e) => {
    // console.log("TestDate:", formData);
    // return false;
    setIsLoading(true);
    const res = await addCampaignData(formData);
    setIsLoading(false);
  };

  const handleModalHide1 = () => setIsErrorModal(false);
  const handleModalHide = () => setIsModal(false);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={handleSubmit}
          className="filter-hamburger show-btn btn btn-transparent"
        >
          {" "}
          {localization.submit}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.createCampaign}
      isLoading={isLoading}
      isGoback
      Buttons={headerBtns}
    >
      <div className="row">
        <div className="col-md-12">
          <PanelCardWithHeading
            title={localization.adsCampaign}
            isLoading={isLoading}
          >
            <div className="col-md-6">
              <DropDownInput
                data={[
                  { id: "Online", name: "Online" },
                  { id: "Offline", name: "Offline" },
                ]}
                label={localization.campaignType}
                required
                errorMsg={localization.requiredName}
                getIdValue={(val) => {
                  setFormData({
                    ...formData,
                    campaign_type: val.id,
                  });
                }}
                isStarRequired={true}
              />
            </div>

            {formData &&
              formData.campaign_type &&
              formData.campaign_type === "Online" && (
                <>
                  <CardSection title={localization.online}>
                    <div className="row">
                      <div className="col-md-6">
                        <DropDownInput
                          data={[
                            {
                              id: "Impression based",
                              name: "Impression based",
                            },
                            { id: "Lead based", name: "Lead based" },
                            { id: "App installs", name: "App installs" },
                            { id: "CTR", name: "CTR" },
                            {
                              id: "Lead conversions",
                              name: "Lead conversions",
                            },
                          ]}
                          label={localization.campaignSubtype}
                          required
                          errorMsg={localization.requiredName}
                          getIdValue={(val) => {
                            setFormData({
                              ...formData,
                              campaign_subtype: val.id,
                            });
                          }}
                          isStarRequired={true}
                        />
                      </div>
                      {formData.campaign_subtype === "Impression based" && (
                        <div className="col-md-6">
                          <ConstantInput
                            label={localization.revenueImpression}
                            errorMsg={localization.required}
                            type="number"
                            handleChange={(value) => {
                              setFormData({
                                ...formData,
                                revenue_impression: value,
                              });
                            }}
                            required
                            isStarRequired={true}
                          />
                        </div>
                      )}
                      {formData.campaign_subtype === "Lead based" && (
                        <div className="col-md-6">
                          <ConstantInput
                            label={localization.revenueLeadBased}
                            errorMsg={localization.required}
                            type="number"
                            handleChange={(value) => {
                              setFormData({
                                ...formData,
                                revenue_lead_based: value,
                              });
                            }}
                            required
                            isStarRequired={true}
                          />
                        </div>
                      )}
                      {formData.campaign_subtype === "App installs" && (
                        <div className="col-md-6">
                          <ConstantInput
                            label={localization.revenueInstall}
                            errorMsg={localization.required}
                            type="number"
                            handleChange={(value) => {
                              setFormData({
                                ...formData,
                                revenue_install: value,
                              });
                            }}
                            required
                            isStarRequired={true}
                          />
                        </div>
                      )}
                      {formData.campaign_subtype === "CTR" && (
                        <div className="col-md-6">
                          <ConstantInput
                            label={localization.revenueCtr}
                            errorMsg={localization.required}
                            type="number"
                            handleChange={(value) => {
                              setFormData({ ...formData, revenue_ctr: value });
                            }}
                            required
                            isStarRequired={true}
                          />
                        </div>
                      )}
                      {formData.campaign_subtype === "Lead conversions" && (
                        <div className="col-md-6">
                          <ConstantInput
                            label={localization.revenueLeadConversion}
                            errorMsg={localization.required}
                            type="number"
                            handleChange={(value) => {
                              setFormData({
                                ...formData,
                                revenue_lead_conversion: value,
                              });
                            }}
                            required
                            isStarRequired={true}
                          />
                        </div>
                      )}
                      <div className="col-md-6">
                        <ConstantInput
                          label={localization.userSegment}
                          errorMsg={localization.required}
                          type="text"
                          handleChange={(value) => {
                            setFormData({ ...formData, user_segment: value });
                          }}
                        />
                      </div>

                      <div className="col-md-6">
                        <ConstantInput
                          label={localization.estRevenue}
                          errorMsg={localization.requiredCompanyName}
                          type="number"
                          handleChange={(value) => {
                            setFormData({ ...formData, est_revenue: value });
                          }}
                          required
                          isStarRequired={true}
                        />
                      </div>

                      <div className="col-md-6 col-sm-12">
                        <DatePicker
                          handleChange={(val) =>
                            setFormData({ ...formData, start_date: val })
                          }
                          label={`Campaign Start Date`}
                          required={true}
                        />
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <DatePicker
                          handleChange={(val) =>
                            setFormData({ ...formData, end_date: val })
                          }
                          label={`Campaign End Date`}
                          required={false}
                        />
                      </div>

                      <div className="col-md-6">
                        <TextAreaInput
                          inputValue={
                            formData?.user_remark !== null
                              ? formData?.user_remark
                              : ""
                          }
                          className={`${
                            !formData.user_remark && "empty"
                          } inline-css scrollbar-styling`}
                          rows={4}
                          type="text"
                          label={localization.userRemark}
                          handleChange={(e) =>
                            setFormData({
                              ...formData,
                              user_remark: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <FileUpload
                          id="attactment"
                          multiple
                          accept=".pdf,.png,.jpg,.jpeg,.doc"
                          required
                          isStarRequired={true}
                          documentUploadUrl={documentUploadUrlPublic}
                          onChange={(val) =>
                            setFormData({ ...formData, attachment: val })
                          }
                        >
                          <span className="btn btn-transparent">
                            {localization.poMouDeal}
                          </span>
                        </FileUpload>
                      </div>
                    </div>
                  </CardSection>
                  <CardSection title={localization.pocDetails}>
                    <div className="row">
                      <div className="col-md-6">
                        <ConstantInput
                          label={localization.pocName}
                          errorMsg={localization.required}
                          type="text"
                          handleChange={(value) => {
                            setFormData({ ...formData, poc_name: value });
                          }}
                        />
                      </div>
                      <div className="col-md-6">
                        <ConstantInput
                          label={localization.pocEmail}
                          errorMsg={localization.required}
                          type="email"
                          handleChange={(value) => {
                            setFormData({ ...formData, poc_mail: value });
                          }}
                        />
                      </div>
                      <div className="col-md-6">
                        <ConstantInput
                          label={localization.pocMobileNumber}
                          errorMsg={localization.required}
                          type="number"
                          handleChange={(value) => {
                            setFormData({
                              ...formData,
                              poc_mobile_number: value,
                            });
                          }}
                          tenDigitsValidation={true}
                        />
                      </div>
                    </div>
                  </CardSection>
                </>
              )}

            {/* offline campaigns code starts */}
            {formData &&
              formData.campaign_type &&
              formData.campaign_type === "Offline" && (
                <>
                  <CardSection title={localization.offline}>
                    <div className="row">
                      <div className="col-md-6">
                        <ConstantInput
                          label={localization.pidNumber}
                          errorMsg={localization.required}
                          type="number"
                          handleChange={(value) => {
                            setFormData({ ...formData, pid_number: value });
                          }}
                          required
                          isStarRequired={true}
                        />
                      </div>
                      <div className="col-md-6">
                        <ConstantInput
                          label={localization.pidName}
                          errorMsg={localization.required}
                          type="text"
                          handleChange={(value) => {
                            setFormData({ ...formData, pid_name: value });
                          }}
                          required
                          isStarRequired={true}
                        />
                      </div>
                      <div className="col-md-6">
                        <ConstantInput
                          label={localization.vendorName}
                          errorMsg={localization.required}
                          type="name"
                          handleChange={(value) => {
                            setFormData({ ...formData, vendor_name: value });
                          }}
                          required
                          isStarRequired={true}
                        />
                      </div>
                      <div className="col-md-6">
                        <ConstantInput
                          label={localization.estRevenue}
                          errorMsg={localization.required}
                          type="number"
                          handleChange={(value) => {
                            setFormData({ ...formData, est_revenue: value });
                          }}
                          required
                          isStarRequired={true}
                        />
                      </div>

                      <div className="col-md-6 col-sm-12">
                        <DatePicker
                          handleChange={(val) =>
                            setFormData({ ...formData, carnival_date: val })
                          }
                          label={`Carnival Date`}
                          required={true}
                        />
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <DatePicker
                          handleChange={(val) =>
                            setFormData({ ...formData, start_date: val })
                          }
                          label={`Campaign Start Date`}
                          required={true}
                        />
                      </div>
                      <div className="col-md-6 col-sm-12">
                        <DatePicker
                          handleChange={(val) =>
                            setFormData({ ...formData, end_date: val })
                          }
                          label={`Campaign End Date`}
                          required={false}
                        />
                      </div>

                      <div className="col-md-6 ">
                        <TextAreaInput
                          inputValue={
                            formData?.user_remark !== null
                              ? formData?.user_remark
                              : ""
                          }
                          className={`${
                            !formData.user_remark && "empty"
                          } inline-css scrollbar-styling`}
                          rows={4}
                          type="text"
                          label={localization.userRemark}
                          handleChange={(e) =>
                            setFormData({
                              ...formData,
                              user_remark: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <FileUpload
                          id="attactment"
                          multiple
                          accept=".pdf,.png,.jpg,.jpeg,.doc"
                          required
                          isStarRequired={true}
                          documentUploadUrl={documentUploadUrlPublic}
                          onChange={(val) =>
                            setFormData({ ...formData, attachment: val })
                          }
                        >
                          <span className="btn btn-transparent">
                            {localization.poMouDeal}
                          </span>
                        </FileUpload>
                      </div>
                    </div>
                  </CardSection>

                  <CardSection title={localization.pocDetails}>
                    <div className="row">
                      <div className="col-md-6">
                        <ConstantInput
                          label={localization.pocName}
                          errorMsg={localization.required}
                          type="text"
                          handleChange={(value) => {
                            setFormData({ ...formData, poc_name: value });
                          }}
                        />
                      </div>
                      <div className="col-md-6">
                        <ConstantInput
                          label={localization.pocEmail}
                          errorMsg={localization.required}
                          type="email"
                          handleChange={(value) => {
                            setFormData({ ...formData, poc_mail: value });
                          }}
                        />
                      </div>
                      <div className="col-md-6">
                        <ConstantInput
                          label={localization.pocMobileNumber}
                          errorMsg={localization.required}
                          type="number"
                          handleChange={(value) => {
                            setFormData({
                              ...formData,
                              poc_mobile_number: value,
                            });
                          }}
                          tenDigitsValidation={true}
                        />
                      </div>
                    </div>
                  </CardSection>
                </>
              )}
            <ModalPop
              title={localization.conf}
              show={isModal}
              handleModalHide={handleModalHide}
              keyboard
              backdrop
            >
              <div className="text-center">
                <div className="success">
                  <img src={Images?.tick} alt="" />
                </div>
                <h5>{"Campaign created successfully"}</h5>
                <div className="d-inline-flex">
                  <a
                    className="btn btn-primary"
                    href="campaign-list"
                    onClick={() => window.location.reload()}
                  >
                    Back to list
                  </a>
                </div>
              </div>
            </ModalPop>

            <ErrModalPop
              title={localization.error}
              show={isErrorModal}
              handleModalHide={handleModalHide1}
              keyboard
              backdrop
            >
              <div className="text-center">{errorMsg}</div>
            </ErrModalPop>
          </PanelCardWithHeading>
        </div>
      </div>
    </Layout>
  );
};

export default CampaignCreation;
